import PropTypes from 'prop-types';
import React from 'react';

import Paragraph, { TYPES } from 'components/Paragraph';
import Strong from 'components/Strong';
import Theme from 'styles/theme';

const Caption = ({ text }) => (
  <div className="CollectionLifestyleCard__caption">
    <Paragraph className="CollectionLifestyleCard__caption-text" type={TYPES.INVERSE}>
      <Strong>{text}</Strong>
    </Paragraph>
    <style jsx>
      {`
        .CollectionLifestyleCard__caption {
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 35%;
          background-image: linear-gradient(to bottom, transparent, ${Theme.get('colors-black')});
        }
      `}
    </style>
    <style jsx global>
      {`
        .CollectionLifestyleCard__caption-text {
          position: absolute;
          bottom: ${Theme.get('spacing') / 2}px;
          left: ${Theme.get('spacing') * 4}px;
          right: ${Theme.get('spacing') * 4}px;
        }
      `}
    </style>
  </div>
);

Caption.propTypes = {
  text: PropTypes.string.isRequired,
};

export default Caption;
